import { Link, usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Plus } from "lucide-react"
import { displayName } from "@/lib/utils"
import type { SharedProps } from "@/types"

export function Header() {
  const { currentUser } = usePage<SharedProps>().props

  return (
    <header className="border-b border-border">
      <div className="container mx-auto px-4 h-14 flex items-center justify-between">
        <Link href="/" className="font-mono text-lg font-bold tracking-tight glitch-subtle" data-text="BROKEN SOUNDS">
          BROKEN SOUNDS
        </Link>

        <nav className="flex items-center gap-4">
          {currentUser && (
            <Button asChild size="sm" className="btn-ghost-shadow">
              <Link href="/samples/new">
                <Plus className="h-4 w-4 mr-1" />
                Upload
              </Link>
            </Button>
          )}
          {currentUser ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="gap-2">
                  <Avatar className="h-6 w-6">
                    <AvatarImage src={currentUser.avatar_url ?? undefined} />
                    <AvatarFallback>{displayName(currentUser)[0]}</AvatarFallback>
                  </Avatar>
                  <span className="hidden sm:inline">{displayName(currentUser)}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem asChild>
                  <Link href={`/users/${currentUser.id}`}>Profile</Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link href={`/users/${currentUser.id}/edit`}>Settings</Link>
                </DropdownMenuItem>
                {currentUser.roles.includes("admin") && (
                  <DropdownMenuItem asChild>
                    <Link href="/admin">Admin</Link>
                  </DropdownMenuItem>
                )}
                <DropdownMenuItem asChild>
                  <Link href="/logout" method="delete" as="button" className="w-full">
                    Sign out
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <Button asChild>
              <Link href="/login">Sign in</Link>
            </Button>
          )}
        </nav>
      </div>
    </header>
  )
}
